import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';

import { APIListingResponseInterface } from '@app/core/_common/model';
import { environment } from '@app/env-service';
import { IWarehouseGroup } from 'v2/modules';

@Injectable({
  providedIn: 'root',
})
export class WarehouseGroupService {
  private readonly _warehouseGroups = new BehaviorSubject<IWarehouseGroup[]>(
    <IWarehouseGroup[]>[],
  );
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);

  warehouseGroup$ = this._warehouseGroups.asObservable();
  loading$ = this._loading.asObservable();

  constructor(private http :HttpClient) {}

  getById(id :number) :Observable<any> {
    return this.http.get(
      `${environment.urlV2}/location/warehouse-groups/${id}`,
      {},
    );
  }

  getAll(params ?:{ [param :string] :string | string[] }) :Subscription {
    this._loading.next(true);

    return this.http
      .get(`${environment.urlV2}/location/warehouse-groups`, { params })
      .subscribe(
        (response :APIListingResponseInterface) => {
          this._loading.next(false);
          if (!params.all || response.meta.current_page === 1) {
            this._warehouseGroups.next(response.data);
          } else {
            const existingGroups :IWarehouseGroup[] =
              this._warehouseGroups.getValue();
            this._warehouseGroups.next(existingGroups.concat(response.data));
          }
          if (params.all && response.meta.current_page < response.meta.last_page) {
            const nextParams = params;
            nextParams.page = (response.meta.current_page + 1).toString();
            this.getAll(nextParams);
          }
        },
        (response :any) => throwError(response.error),
      );
  }

  pullInboundShipments(days :any) :Observable<any> {
    return this.http.post(
      `${environment.urlV2}/location/warehouse-groups/pull-inbound-shipments`,
      {
        days,
      },
    );
  }

  pullExternalWarehouseStocks() :Observable<any> {
    return this.http.post(
      `${environment.urlV2}/location/warehouse-groups/pull-external-warehouse-stocks`,
      {},
    );
  }
}
